import React, { useState, useEffect, useContext } from "react";

import { makeStyles, useTheme } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import * as Sentry from "@sentry/react";
import {
  Typography,
  Box,
  Divider,
  Button,
  InputAdornment,
  OutlinedInput,
  Tooltip,
  IconButton,
  TextField,
} from "@material-ui/core";
import { BsCreditCard } from "react-icons/bs";
import { FaPiggyBank } from "react-icons/fa";
import { BsExclamationCircle } from "react-icons/bs";
import { MdContentCopy } from "react-icons/md";
import { GiReceiveMoney } from "react-icons/gi";
import { CoinContext } from "../../contexts/CoinContext";
import { REACT_APP_PROD_URL, PRICES_URL } from "../../services/configs";
import useResizer from "../../services/useResizer";
import Icon from "../../fontIcons/icon";
import { useSelector } from "react-redux";
import fetcher from "../../api/swr_fetcher";
import { useQuery } from "react-query";

export default function INRWithdraw() {
  const classes = useStyles();
  const theme = useTheme();
  let history = useHistory();
  const isMobile = useResizer();

  const token = useSelector((state) => state.trading.TOKEN);

  const [inrBalance, setInrBalance] = useState(0);
  const [inOrder, setInOrder] = useState(0);
  // const [accountNum, setAccountNum] = useState("");
  // const [ifsc, setIfsc] = useState("");
  // const [name, setName] = useState("");
  const [amount, setAmount] = useState("");
  const [inrConfigData, setInrConfigData] = useState();
  const [userBankAcc, setUserBankAcc] = useState({
    accountNumber: "",
    ifsc: "",
    name: "",
  });
  const [limit, setLimit] = useState({
    min: 500,
    max: 2000000,
  });
  const [verify, setVerify] = useState(false);
  const [transferId, setTransferId] = useState(null);
  const [otp, setOtp] = useState(null);

  const [errorFields, setErrorFields] = useState({
    amt: false,
    otp: false,
  });

  const [doubleClick, setDoubleClick] = useState(false);

  const [counter, setCounter] = useState(120);
  const [startTimer, setStartTimer] = useState(false);

  const { handleClickAlert, kycData, bannedTimeout } = useContext(CoinContext);

  // get INR balance and min/max withdrawal amount
  function getInrConfig() {
    fetcher(`/v1/inrConfig`)
      .then((data) => {
        // console.log(data);
        setInrConfigData(data);
        if (data.minWithdraw && data.maxWithdraw) {
          setLimit({
            min: data.minWithdraw,
            max: data.maxWithdraw,
          });
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }
  useEffect(() => {
    getINRBalance();
    getInrConfig();
  }, []);

  function getINRBalance() {
    if (token) {
      fetcher(`/v1/balances/INR`)
        .then((data) => {
          // console.log(data);
          if (data[0]) {
            setInrBalance(data[0].availableBalance);
            setInOrder(data[0].inOrderBalance);
          }
        })
        .catch((err) => {
          console.error(err);
          // console.error(err);
        });
      // console.log("Getting INR balance");
    }
  }

  // get account details
  useEffect(() => {
    if (token) {
      var bearer = "Bearer " + token;
      fetcher(`/v1/um/bankAccount`)
        .then((data) => {
          // console.log(data);
          setUserBankAcc(data);
        })
        .catch((err) => {
          console.error(err);
          // console.error(err);
        });
      // console.log("Getting user account details");
    }
  }, [token]);

  // withdraw inr request
  function withdraw() {
    if (token && userBankAcc && amount) {
      fetcher(`/v1/balances/INR`)
        .then((data) => {
          // console.log(data);
          if (data[0]) {
            setInrBalance(data[0].availableBalance);
            setInOrder(data[0].inOrderBalance);

            if (
              amount >= Number(limit.min) &&
              amount <= Number(data[0].availableBalance) &&
              amount <= Number(limit.max)
            ) {
              fetcher(`/v1/transfers/inr`, {
                method: "POST",
                body: {
                  accountNo: userBankAcc.accountNumber.split(/\s/).join(""),
                  ifsc: userBankAcc.ifsc.split(/\s/).join(""),
                  amount: amount,
                  transferType: "IMPS",
                  note: "trial",
                },
              })
                .then((data) => {
                  // console.log(data);
                  if (data.id) {
                    setStartTimer(true);
                    handleClickAlert(
                      "warning",
                      `Enter email OTP to verify withdrawal request`
                    );
                    setErrorFields({
                      ...errorFields,
                      amt: false,
                    });

                    setTransferId(data.id);
                    setVerify(true);

                    setDoubleClick(false);
                  }
                  getINRBalance();
                  getInrConfig();
                })
                .catch((err) => {
                  if (err?.info?.detail) {
                    const messageRes = err.info.detail;
                    const actualMessage = messageRes.substring(
                      messageRes.indexOf('"') + 1,
                      messageRes.length - 1
                    );
                    handleClickAlert("error", actualMessage);
                  }
                  setTransferId(null);
                  setDoubleClick(false);
                });

              // console.log("Making withdraw request");
            } else {
              if (amount > Number(data[0].availableBalance)) {
                handleClickAlert(
                  "error",
                  `Request failed, insufficient balance`
                );
              } else {
                setErrorFields({
                  ...errorFields,
                  amt: true,
                });
              }
              setDoubleClick(false);
            }
          }
        })
        .catch((err) => {
          console.error(err);
          handleClickAlert("error", err.info.detail);
          // console.error(err);
        });
    } else {
      setErrorFields({
        ...errorFields,
        amt: true,
      });
      setDoubleClick(false);
    }
  }

  function verifyWithdraw() {
    if (otp && transferId) {
      var bearer = "Bearer " + token;
      fetcher(`/v1/transfers/inr/verify`, {
        method: "POST",
        body: {
          transferId: transferId,
          otp: otp,
        },
      })
        .then((data) => {
          // console.log(data);
          if (data.status === "AWAITING_ADMIN_ACTION") {
            handleClickAlert("success", `Request sent`);
          }
          getINRBalance();
          setAmount("");
          setOtp("");
          setTransferId("");
          setVerify(false);
          setErrorFields({
            ...errorFields,
            otp: false,
          });
          setDoubleClick(false);
          setTransferId(null);
          // console.log("Verifying request");
        })
        .catch((err) => {
          if (err.status === 400) {
            handleClickAlert("error", err.info.detail);
          } else {
            handleClickAlert("error", err.info.detail);
          }
          setDoubleClick(false);
        });
    } else {
      setErrorFields({
        ...errorFields,
        otp: true,
      });
      setDoubleClick(false);
    }
  }

  function resendOtp() {
    if (transferId) {
      setStartTimer(true);
      var bearer = "Bearer " + token;
      fetcher(`/v1/transfers/resendOtp/${transferId}`, { method: "POST" })
        .then((res) => {
          handleClickAlert("success", "OTP resent");

          // console.log(res);
        })
        .catch((err) => {
          handleClickAlert("error", err.info.detail);
          console.error(err);
          // console.error(err);
        });
    } else {
      handleClickAlert("error", "Failed to resend OTP");
    }
  }

  const padTime = (time) => {
    return String(time).length === 1 ? `0${time}` : `${time}`;
  };

  const format = (time) => {
    // Convert seconds into minutes and take the whole part
    const minutes = Math.floor(time / 60);

    // Get the seconds left after converting minutes
    const seconds = time % 60;

    //Return combined values as string in format mm:ss
    return `${minutes}:${padTime(seconds)}`;
  };

  useEffect(() => {
    let timer;
    if (counter > 0 && startTimer) {
      timer = setTimeout(() => setCounter((c) => c - 1), 1000);
    } else if (counter === 0) {
      setStartTimer(false);
      setCounter(120);
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [counter, startTimer]);
  const userConfig = useQuery(["userconfig"], async () => {
    return await fetcher("/v1/userConfigs");
  });

  return (
    <div className={classes.container}>
      <h1 className="mb-3">Withdraw INR to Bank</h1>
      <p className="font-light mb-5">
        <span
          className="underline cursor-pointer"
          onClick={() => {
            if (isMobile) {
              history.push("/wallet/inr");
            } else {
              history.push(`/wallet/inr`);
            }
          }}
        >
          INR Wallet
        </span>{" "}
        {">"}
        <span style={{ color: "#3AC4AB" }}> Withdraw INR</span>
      </p>

      <div className={classes.gridContainer}>
        <div className="dark:bg-[#141828] bg-[#eee] p-5 rounded-md">
          <div className={`${classes.flexContainer} mb-3`}>
            {/* <BsCreditCard style={{ fontSize: "20px" }} /> */}
            <Icon icon={"inr"} size={20} className="mr-2"></Icon>{" "}
            <p
              style={{
                fontSize: "16px",
                fontWeight: "bold",
              }}
            >
              INR Wallet Balance
            </p>
          </div>
          <div className={classes.flexContainer} style={{ marginTop: "5px" }}>
            <div className="w-full flex items-center">
              <p className={`${classes.ptitle} text-sm`}>Available</p>
              <p className={classes.pvalue}>
                {" "}
                <Icon icon={"inr"} size={10} className=""></Icon>{" "}
                {Number(inrBalance).toFixed(2)}
              </p>
            </div>{" "}
          </div>
          <div className={classes.flexContainer}>
            <div
              className="flex whitespace-nowrap items-center w-full"
              style={{ marginTop: "5px" }}
            >
              <p className={`${classes.ptitle} text-sm`}>In Order</p>
              <p className={classes.pvalue}>
                <Icon icon={"inr"} size={10} className=""></Icon>{" "}
                {Number(inOrder).toFixed(2)}
              </p>
            </div>
          </div>
          <div className={classes.flexContainer} style={{ marginTop: "5px" }}>
            <p className={`${classes.ptitle} text-sm`}>Total</p>
            <p className={classes.pvalue}>
              <Icon icon={"inr"} size={10} className=""></Icon>{" "}
              {(Number(inrBalance) + Number(inOrder)).toFixed(2)}
            </p>
          </div>
        </div>

        <Divider />
        {userConfig?.isSuccess ? (
          <div className={classes.subContainer}>
            <div className={classes.notice}>
              <p
                style={{
                  margin: 0,
                  fontSize: "18px",
                  fontWeight: "bold",
                  color: "#3AC4AB",
                }}
              >
                {userConfig?.data?.iw
                  ? "Please Note"
                  : "INR withdrawals are temporarily paused."}
              </p>
              {/* <ol className="ml-4">
              <li>
                {" "}
                <p>
                  The INR withdraw amount should be greater than ₹ {limit.min}{" "}
                  and less than ₹ {Number(limit.max).toLocaleString("en-IN")}.
                </p>
              </li>
              <li>
                <p>
                  A fee of 20 INR is charged for Amounts below 1000 INR, No fee
                  above 1000 INR.
                </p>
              </li>
              <li>
                <p>
                  All requests can take 4 to 5 working days to process, due to
                  banking limitations.
                </p>
              </li>
              <li>
                <p>
                  Unverified INR Withdrawals are automatically cancelled after
                  10 mins and the balance is credited back to the wallet.
                </p>
              </li>
            </ol> */}
              {userConfig?.data?.iw ? (
                <div className="ml-4">
                  {Boolean(inrConfigData?.max30dWithdrawLimit) ? (
                    <div className="flex flex-wrap gap-y-3 items-center md:gap-x-7">
                      <div>
                        <p className="text-sm mt-2 font-normal">
                          30 Day Withdrawal Limit:
                        </p>
                        <p className="text-sm mt-1 font-medium">
                          ₹ {inrConfigData?.max30dWithdrawLimit || 0}{" "}
                        </p>
                      </div>
                      <div>
                        <p className="text-sm mt-2 font-normal">
                          Current Available Limit:
                        </p>
                        <p className="text-sm mt-1 font-medium">
                          ₹ {inrConfigData?.limitAvailable || 0}
                        </p>
                      </div>
                    </div>
                  ) : (
                    <>
                      <p className="text-sm mt-2 font-normal">
                        Max Withdraw Limit:
                      </p>
                      <p className="text-sm mt-1 font-medium">
                        ₹ 200000{" "}
                        <span className="font-normal">(Per Transaction)</span>{" "}
                      </p>
                    </>
                  )}
                  <p className="text-sm mt-4 font-normal">
                    All withdrawal requests can take{" "}
                    <span className="font-medium">4 to 5</span> banking days to
                    process, due to banking limitations.{" "}
                  </p>
                </div>
              ) : (
                <div className="ml-4 my-3">
                  <p className="text-sm font-normal">
                    We are enabling INR withdrawals with limits due to banking
                    restrictions. Please contact us on Chat Support to enable
                    INR Withdrawals.
                  </p>
                </div>
              )}
            </div>
          </div>
        ) : (
          <></>
        )}
        <Divider style={{ marginTop: "8px" }} />
        <div className={classes.subContainer}>
          <div className={classes.flexContainer}>
            <FaPiggyBank style={{ fontSize: "20px", color: "#3AC4AB" }} />
            <p
              style={{
                color: "#3AC4AB",
                fontWeight: "bold",
                marginLeft: "15px",
              }}
            >
              Your bank account details:
            </p>
          </div>
          <div className={classes.flexContainer} style={{ marginTop: "5px" }}>
            <p className={classes.ptitle}>Beneficiary Name</p>
            <p className={`${classes.pvalue} ml-3`}>{userBankAcc.name}</p>
            <div className={classes.grow} />
          </div>
          <div className={classes.flexContainer} style={{ marginTop: "5px" }}>
            <p className={classes.ptitle}>Account Number</p>
            <p className={`${classes.pvalue} ml-3`}>
              {userBankAcc.accountNumber}
            </p>
            <div className={classes.grow} />
          </div>
          <div className={classes.flexContainer} style={{ marginTop: "5px" }}>
            <p className={classes.ptitle}>IFSC</p>
            <p className={`${classes.pvalue} ml-3`}>{userBankAcc.ifsc}</p>
            <div className={classes.grow} />
          </div>
        </div>
        <Divider />
        <div className={classes.subContainer}>
          <div className={classes.flexContainer}>
            <GiReceiveMoney style={{ fontSize: "26px", color: "#92989B" }} />
            <p
              style={{
                color: "#92989B",
                fontSize: "16px",
                fontWeight: "bold",
                marginLeft: "15px",
              }}
            >
              Withdraw Amount
            </p>
          </div>
          <Box mt={1} mb={3}>
            <TextField
              id="outlined-adornment-amount"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">&#x20B9;</InputAdornment>
                ),
                inputProps: { maxLength: 7 },
              }}
              fullWidth={true}
              variant="outlined"
              className={classes.textFieldStyles}
              value={amount}
              onChange={(e) => {
                let val = e.target.value.replace(/[^0-9]$/, "");
                setAmount(val);
              }}
              error={errorFields.amt}
              helperText={
                errorFields.amt
                  ? `Please make sure the amount entered is above ${limit.min}`
                  : null
              }
              onKeyUp={(event) => {
                if (event.key === "Enter" || event.key === "NumpadEnter") {
                  withdraw();
                }
              }}
              disabled={verify}
            />
          </Box>

          {verify ? (
            <>
              <p
                style={{
                  color: "#92989B",
                  fontSize: "16px",
                  fontWeight: "bold",
                  marginLeft: "15px",
                }}
              >
                Email OTP
              </p>
              <Box mt={1}>
                <TextField
                  id="otp"
                  fullWidth={true}
                  variant="outlined"
                  className={classes.textFieldStyles}
                  value={otp}
                  onChange={(e) => {
                    let val = e.target.value.replace(/[^0-9.]*$/, "");
                    setOtp(val);
                  }}
                  error={errorFields.otp}
                  helperText={errorFields.otp ? "Please enter the otp" : null}
                  onKeyUp={(event) => {
                    if (event.key === "Enter" || event.key === "NumpadEnter") {
                      verifyWithdraw();
                    }
                  }}
                />
              </Box>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginBottom: "24px",
                  color: theme.palette.primary.main,
                  marginTop: "5px",
                }}
              >
                {counter === 0 || counter === 120 ? (
                  <p onClick={resendOtp} className={classes.link}>
                    Resend OTP
                  </p>
                ) : (
                  <div>Resend OTP in {format(counter)}</div>
                )}
              </div>
            </>
          ) : null}

          <Box display="flex" justifyContent="flex-end" mb={2}>
            <Button
              variant="contained"
              disableElevation
              disabled={doubleClick}
              color="primary"
              style={{
                width: isMobile ? "100%" : "25%",
                height: "40px",
                marginTop: "8px",
                color: "white",
                fontWeight: "bold",
                textTransform: "none",
                borderRadius: "6px",
              }}
              onClick={() => {
                setDoubleClick(true);
                if (verify) {
                  verifyWithdraw();
                } else {
                  withdraw();
                }
              }}
            >
              {verify ? "Verify" : "Withdraw"}
            </Button>
          </Box>
        </div>
      </div>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  gridContainer: {
    background: theme.palette.type === "dark" ? "#151828" : "white",
    marginTop: "20px",
    paddingTop: "3px",
    // [theme.breakpoints.up("md")]: {
    //   marginRight: "50px",
    // },
  },
  ptitle: {
    width: "35%",
    color: "#9fa1a0",
    fontSize: "14px",
  },
  pvalue: {
    fontSize: "14px",
    fontWeight: "bold",
    color: "#92989B",
  },
  textFieldRoot: {
    "& > p": {
      color: theme.palette.text.primary,
      opacity: 0.5,
      fontSize: "13px",
      lineHeight: "16px",
    },
  },
  textFieldStyles: {
    border: `1px solid ${theme.palette.text.primary}40`,
    borderRadius: 3,
    "&::before": {
      display: "none",
    },
    "& input": {
      padding: "12px 14px",
      color: theme.palette.text.primary,
      fontWeight: "bold",
      "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
        "-webkit-appearance": "none",
        margin: 0,
      },
    },
  },
  fieldLabel: {
    fontWeight: "bold",
    color: theme.palette.text.primary,
    opacity: "0.5",
    textTransform: "uppercase",
    marginTop: "17px",
    [theme.breakpoints.down("xs")]: {
      fontSize: "0.8rem",
    },
    [theme.breakpoints.up("sm")]: {
      fontSize: "1rem",
    },
  },
  notice: {
    border: `1px solid #3AC4AB`,
    backgroundColor: "rgba(86,195,164,0.1)",
    padding: "15px",
    marginTop: "20px",
    marginLeft: "15px",
    marginRight: "15px",
    [theme.breakpoints.down("sm")]: {
      marginBottom: "15px",
    },
    borderRadius: "8px",
  },
  container: {
    flexGrow: 1,
    [theme.breakpoints.up("lg")]: {
      width: "52%",
    },
    marginLeft: "auto",
    marginRight: "auto",
  },
  link: {
    fontWeight: "bold",
    color: theme.palette.primary.text,
    paddingLeft: "10px",
    "&:hover": {
      cursor: "pointer",
      textDecoration: "underline",
    },
  },
  grow: {
    flexGrow: 1,
  },
  subContainer: {
    marginTop: "15px",
    marginLeft: "20px",
    paddingBottom: "15px",
    marginRight: "15px",
  },
  flexContainer: {
    display: "flex",
    alignItems: "center",
  },
  copyIcon: {
    fontSize: "20px",
    color: "#3AC4AB",
    // "&:hover": {
    //   cursor: "pointer",
    // },
  },
}));
